import { Flex, Text } from '@approvalmax/ui/src/components';
import { selectors } from 'modules/common';
import { domain, State } from 'modules/data';
import { FC, memo } from 'react';
import { useSelector } from 'react-redux';

import { getActiveTemplate, getVersionHistory, isPageReadonly } from '../../selectors/pageSelectors';
import Actions from './components/Actions/Actions';
import EditWorkflowName from './components/EditWorkflowName/EditWorkflowName';
import { getWarnText } from './Toolbar.helpers';
import { ToolbarProps } from './Toolbar.types';

const Toolbar: FC<ToolbarProps> = memo((props) => {
    const { helpStripeId } = props;

    const template = useSelector(getActiveTemplate)!;
    const company = useSelector((state: State) => selectors.company.getCompanyById(state, template.companyId));
    const integrationErrorPreventsWork = Boolean(!company.flags.hasActiveIntegration && template.integrationCode);
    const expandedTemplate = selectors.template.expandTemplate(template);
    const integrationType = selectors.integration.getIntegrationType(template.integrationCode);
    const versionHistory = useSelector(getVersionHistory);
    const readonly = useSelector(isPageReadonly);
    const canRename = !readonly && integrationType === domain.IntegrationType.None;
    const warnText = getWarnText({
        company,
        integrationType,
        hasIntegrationError: integrationErrorPreventsWork,
        template,
        versionHistory,
    });

    return (
        <Flex
            alignItems='center'
            justifyContent='space-between'
            wrap={false}
            data-starter-guide='wf_pulling_docs_heading'
        >
            <div>
                <Flex spacing='0' alignItems='center' wrap={false}>
                    <Text
                        color='midnight100'
                        font='label'
                        fontSize='medium'
                        fontWeight='medium'
                        spacing='0 12 0 0'
                        data-starter-guide='wf_pulling_docs_KB'
                        ellipsis={1}
                    >
                        {expandedTemplate.workflowName}
                    </Text>

                    {canRename && <EditWorkflowName templateName={expandedTemplate.templateName} />}
                </Flex>

                {warnText && (
                    <Text color='midnight70' font='label' fontSize='small'>
                        {warnText}
                    </Text>
                )}
            </div>

            <Actions helpStripeId={helpStripeId} />
        </Flex>
    );
});

export default Toolbar;
